import ACTIONS from '@/store/storeActions';

const mutations = {
  [ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS_LOADING_STATE]: (state, payload) => {
    state.loadingState.documents = payload;
  },
  /**
   * @param state
   * @param payload
   * @param {String} payload.id - ExerciseId
   * @param {String | Array<String>} payload.documentNames - DocumentName / DocumentNames
   */
  [ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS]: (state, payload) => {
    // check if the payload for the id is already in state
    const exDocIndex = state.exerciseDocuments.findIndex((exDoc) => exDoc.exerciseId === payload.id);
    const isArray = () => (Array.isArray(payload.documentNames) || payload.documentNames instanceof Array)
    const isString = () => (typeof payload.documentNames === 'string' || payload.documentNames instanceof String);
    if (exDocIndex === -1) {
      // doesnt exist
      let entry = {
        exerciseId: payload.id,
        exerciseDocuments: []
      }
      if (isArray()) {
        payload.documentNames.forEach((docName) => {
          entry.exerciseDocuments.push({
            documentName: docName,
            documentUrl: `${payload.id}/${docName}`
          })
        })
      } else if (isString()) {
        entry.exerciseDocuments.push({
          documentName: payload.documentNames,
          documentUrl: `${payload.id}/${payload.documentNames}`
        })
      }

      state.exerciseDocuments.push(entry);
    } else {
      // exerciseDocuments contains the exercise already
      let entry = { ...state.exerciseDocuments[exDocIndex], exerciseDocuments: [] };
      if (isArray()) {
        payload.documentNames.forEach((docName) => {
          entry.exerciseDocuments.push({
            documentName: docName,
            documentUrl: `${payload.id}/${docName}`
          })
        })
      } else if (isString()) {
        entry.exerciseDocuments.push({
          documentName: payload.documentNames,
          documentUrl: `${payload.id}/${payload.documentNames}`
        })
      }

      state.exerciseDocuments.map( ( exDoc, index) => (index === exDocIndex ? entry : exDoc))
    }
  },
}

export default mutations;
